module.exports = __webpack_public_path__ + "img/img_company.626f7fff.jpg";